import store from './store';

// import 'fabric-history';

export let canvas = null;
export let activeObject = null;
export let selectedText = '';
export let isTextSelected = false;
export let scale = 1;
export let scalar = 1.1;
export let lastZoom = {
  width: null,
  height: null,
  zoom: null
}

// Turn off object caching for proper font styles update
// fabric.Object.prototype.objectCaching = false;
// fabric.Object.prototype.statefullCache = false;
// fabric.Object.prototype.noScaleCache = false;

// const canvasModifiedCallback = () => {
//   console.log('test', store.getters['creator/previewGuestIndex'])
//   if (!activeObject || store.getters['creator/isPreview']) {
//     return 
//   }
//   console.log('object modified', this, activeObject && activeObject.id)

//   // canvas.fire('object:modified');

//   // console.log('json', JSON.stringify(canvas.toJSON(['lockMovementX', 'lockMovementY', 'selectable', 'excludeFromSVG', 'id', 'blocked'])))
//     // store.dispatch('creator/setActiveInvitationContent', JSON.stringify(canvas.toJSON(['lockMovementX', 'lockMovementY', 'selectable', 'excludeFromSVG', 'id', 'blocked'])))
//     saveContent()
// }

export function saveContent() {
  store.dispatch('creator/setActiveInvitationContent', JSON.stringify(canvas.toJSON(['lockMovementX', 'lockMovementY', 'selectable', 'excludeFromSVG', 'id', 'blocked'])))

}

// export function listen(event, callback) {
// }

// fabric.IText.prototype.setControlsVisibility({
//   tl:false, //top-left
//   mt:false, // middle-top
//   tr:false, //top-right
//   ml:true, //middle-left
//   mr:true, //middle-right
//   bl:false, // bottom-left
//   mb:false, //middle-bottom
//   br:false //bottom-right
//  })

//  fabric.Object.prototype.borderColor = '#fec2c4';
//  fabric.Object.prototype.cornerColor = '#fec2c4';
//  fabric.Object.prototype.cornerSize = 10;

export function initCanvas() {

    // canvas = new fabric.Canvas(el);

    // canvas.setBackgroundColor('#fff', canvas.renderAll.bind(canvas));

    // // extra canvas settings
    // canvas.preserveObjectStacking = true;
    // canvas.stopContextMenu = true;
    // canvas.centeredScaling = true;
    // canvas.selectionColor = 'rgba(254, 194, 196, .5)';
    // canvas.selectionBorderColor = '#fec2c4';
    // canvas.selection = false;

    // canvas.setWidth(fabric.util.parseUnit('115mm').toFixed(4));
    // canvas.setHeight(fabric.util.parseUnit('170mm').toFixed(4));

    // canvas.on('selection:created', () => {
    //   activeObject = canvas.getActiveObject();

    //   // console.log('selection:created', activeObject, selectedText, isTextSelected);

    //   // const context = document.querySelector('.context');

    //   // if (context) {
    //   //     context.style.display = 'block';
    //   //     context.style.top = `${activeObject.lineCoords.tr.y + 80}px`;
    //   //     context.style.left = `${activeObject.lineCoords.tr.x - 30}px`;
    //   // }
    // })

    // canvas.on('selection:cleared', () => {
    //   activeObject = canvas.getActiveObject();

    //   // const context = document.querySelector('.context');

    //   // if (context) {
    //   //     context.style.display = 'none';
    //   // }
    // })

    // canvas.on('selection:updated', () => {
    //   activeObject = canvas.getActiveObject();

    //   // const context = document.querySelector('.context');

    //   // if (context) {
    //   //     context.style.top = `${activeObject.lineCoords.tr.y + 80}px`;
    //   //     context.style.left = `${activeObject.lineCoords.tr.x - 30}px`;
    //   // }
    // })

    // canvas.on('object:moving', () => {
    //   activeObject = canvas.getActiveObject();

    //   // const context = document.querySelector('.context');

    //   // if (context) {
    //   //     context.style.top = `${activeObject.lineCoords.tr.y + 80}px`;
    //   //     context.style.left = `${activeObject.lineCoords.tr.x - 30}px`;
    //   // }

    //   // if (e.target.id === 'personalizedField') {
    //   //   console.log('guest change', e.target.text);
    //   //   store.dispatch('creator/setGuestPosition', { x: e.target.left, y: e.target.top })
    //   // }
    // })

    // canvas.on('text:changed', function() {
    //   // console.log('text:changed', e.target, e);

    //   // if (e.target.id === 'personalizedField') {
    //   //   console.log('guest change', e.target.text);
    //   //   store.dispatch('creator/setPreviewGuest', { content: e.target.text, display: e.target.text })
    //   // }
    // });

    // canvas.on('text:selection', function(e) {
    //   console.log('text:selection', e.target, e);
    // });

    // // canvas.on('text:selection:changed', function(e) {
    // //   console.log('text:selection:changed', canvas.getActiveObject(), canvas.getActiveObject().getSelectionStyles(), e.target, e);
    // // });


    // canvas.on('object:added', canvasModifiedCallback);
    // canvas.on('object:removed', canvasModifiedCallback);
    // canvas.on('object:modified', canvasModifiedCallback);

    // align and centering lines
    // initCenteringGuidelines(canvas);
    // initAligningGuidelines(canvas);

    return canvas;
}

export function setCanvasSize() {

  // canvas.setWidth(fabric.util.parseUnit(width).toFixed(4));
  // canvas.setHeight(fabric.util.parseUnit(height).toFixed(4));

}

export function refresh() {

  // canvas.on('object:added', canvasModifiedCallback);
  // canvas.on('object:removed', canvasModifiedCallback);
  // canvas.on('object:modified', canvasModifiedCallback);

  // canvas.setBackgroundColor('#fff', canvas.renderAll.bind(canvas));

  // canvas.clearHistory();

  // align and centering lines
  // initCenteringGuidelines(canvas)
  // initAligningGuidelines(canvas)

}

export function getStyle() {
  // return (activeObject.getSelectionStyles && activeObject.isEditing)
  //   ? activeObject.getSelectionStyles()
  //   : activeObject[styleName];
}

export function zoomIn() {

  // scale = scale * scalar;

  // setZoom(
  //   canvas.getWidth() * scalar,
  //   canvas.getHeight() * scalar,
  //   canvas.getZoom() * scalar
  // );

}

export function zoomOut() {

  // scale = scale / scalar;

  // setZoom(
  //   canvas.getWidth() / scalar,
  //   canvas.getHeight() / scalar,
  //   canvas.getZoom() / scalar
  // );

}

export function resetZoom() {

  // setZoom(
  //   canvas.getWidth() / canvas.getZoom(),
  //   canvas.getHeight() / canvas.getZoom(),
  //   1,
  //   save
  // );

}

export function restoreZoom() {

  // if (lastZoom.width) {
  //   setZoom(
  //     lastZoom.width,
  //     lastZoom.height,
  //     lastZoom.zoom
  //   );
  // }

}

export function setZoom() {

  // canvas.setHeight(height);
  // canvas.setWidth(width);
  // canvas.setZoom(zoom);

  // if (save) {
  //   lastZoom.height = height;
  //   lastZoom.width = width;
  //   lastZoom.zoom = zoom;
  // }

  // canvas.renderAll();

}


export function addText() {

  // const object = new fabric.Textbox(text, Object.assign({}, {
  //   fontFamily: 'Arial',
  //   fontSize: 20,
  //   lineHeight: 1.2,
  //   charSpacing: 0,
  //   fill: '#000',
  //   top: 0,
  //   left: 0,
  //   angle: 0,
  //   lockUniScaling: true,
  //   centerTransform: true,
  //   scaleX: 1,
  //   scaleY: 1,
  // }, properties));

  // console.log('dodaj tekst', canvas);
  // canvas.add(object);
  // canvas.viewportCenterObject(object)
  // canvas.renderAll();
}

export function setText() {
  // activeObject.set('text', text);
  // canvas.renderAll();
}

export function addImage() {
  // fabric.Image.fromURL(img, (img) => {
  //   // img.scaleX = '.3';
  //   // img.scaleY = '.3';
  //   img.angle = 0;
  //   img.scaleX = .5;
  //   img.scaleY = .5;

  //   canvas.insertAt(img, 200);
  //   canvas.renderAll();
  // });
}

export function styleActiveObject() {

    // selectedText = checkSelected && activeObject.getSelectedText();
    // isTextSelected = checkSelected && !!selectedText.length;

    // console.log('activeObject', activeObject);
    // console.log(isTextSelected);


    // if (isTextSelected) {
    //   console.log('style for selected text')
    //   const selectionStyles = activeObject.getSelectionStyles()
    //   console.log('selectionStyles', selectionStyles);
    //   const hasStyle = toggleValue && selectionStyles.length && selectionStyles.every((letter) => letter[property] == value);
    //   activeObject.setSelectionStyles({ [property]: hasStyle ? '' : value });
    // } else {
    //   console.log('style for object')
    //     const hasStyle = toggleValue && activeObject[property] == value;
    //     const newVal = hasStyle ? '' : value;

    //     // If selection has own styles and we set style for whole
    //     // object then we have to override/set the same style for
    //     // every item in selection
    //     if (checkSelected) {
    //       Object.values(activeObject.styles).forEach((row) => {
    //         Object.values(row).map((item) => {
    //           if (Object.prototype.hasOwnProperty.call(item, property)) {
    //             item[property] = newVal;
    //           }
    //         })
    //       })
    //     }

    //     activeObject.set(property, newVal);
    // }

    // canvas.renderAll();

    // // Save the change to history
    // canvas._historySaveAction();

    // // save current state of canvas
    // canvasModifiedCallback();
}

/**
 * Convert images for export into base64
 */
// fabric.Image.prototype.getSvgSrc = function() {
//   return this.toDataURLforSVG();
// }

// fabric.Image.prototype.toDataURLforSVG = function(options) {
//   var el = fabric.util.createCanvasElement();
//         el.width  = this._element.naturalWidth || this._element.width;
//         el.height = this._element.naturalHeight || this._element.height;
//   el.getContext('2d').drawImage(this._element, 0, 0);
//   var data = el.toDataURL(options);
//   return data;
// }

/**
 * Get element by unique id
 */
// fabric.Canvas.prototype.getObjectById = function(id) {
//   var object = null,
//       objects = this.getObjects();

//   for (var i = 0, len = this.size(); i < len; i++) {
//     if (objects[i].id && objects[i].id === id) {
//       object = objects[i];
//       break;
//     }
//   }

//   return object;
// }

// function initAligningGuidelines(canvas) {

//   var ctx = canvas.getSelectionContext(),
//       aligningLineOffset = 5,
//       aligningLineMargin = 4,
//       aligningLineWidth = 1,
//       aligningLineColor = 'rgb(0,255,0)',
//       viewportTransform,
//       zoom = 1;

//   function drawVerticalLine(coords) {
//     drawLine(
//       coords.x + 0.5,
//       coords.y1 > coords.y2 ? coords.y2 : coords.y1,
//       coords.x + 0.5,
//       coords.y2 > coords.y1 ? coords.y2 : coords.y1);
//   }

//   function drawHorizontalLine(coords) {
//     drawLine(
//       coords.x1 > coords.x2 ? coords.x2 : coords.x1,
//       coords.y + 0.5,
//       coords.x2 > coords.x1 ? coords.x2 : coords.x1,
//       coords.y + 0.5);
//   }

//   function drawLine(x1, y1, x2, y2) {
//     ctx.save();
//     ctx.lineWidth = aligningLineWidth;
//     ctx.strokeStyle = aligningLineColor;
//     ctx.beginPath();
//     ctx.moveTo(((x1+viewportTransform[4])*zoom), ((y1+viewportTransform[5])*zoom));
//     ctx.lineTo(((x2+viewportTransform[4])*zoom), ((y2+viewportTransform[5])*zoom));
//     ctx.stroke();
//     ctx.restore();
//   }

//   function isInRange(value1, value2) {
//     value1 = Math.round(value1);
//     value2 = Math.round(value2);
//     for (var i = value1 - aligningLineMargin, len = value1 + aligningLineMargin; i <= len; i++) {
//       if (i === value2) {
//         return true;
//       }
//     }
//     return false;
//   }

//   var verticalLines = [],
//       horizontalLines = [];

//   canvas.on('mouse:down', function () {
//     viewportTransform = canvas.viewportTransform;
//     zoom = canvas.getZoom();
//   });

//   canvas.on('object:moving', function(e) {

//     var activeObject = e.target,
//         canvasObjects = canvas.getObjects(),
//         activeObjectCenter = activeObject.getCenterPoint(),
//         activeObjectLeft = activeObjectCenter.x,
//         activeObjectTop = activeObjectCenter.y,
//         activeObjectBoundingRect = activeObject.getBoundingRect(),
//         activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
//         activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
//         horizontalInTheRange = false,
//         verticalInTheRange = false,
//         transform = canvas._currentTransform;

//     if (!transform) return;

//     // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
//     // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move

//     for (var i = canvasObjects.length; i--; ) {

//       if (canvasObjects[i] === activeObject) continue;

//       var objectCenter = canvasObjects[i].getCenterPoint(),
//           objectLeft = objectCenter.x,
//           objectTop = objectCenter.y,
//           objectBoundingRect = canvasObjects[i].getBoundingRect(),
//           objectHeight = objectBoundingRect.height / viewportTransform[3],
//           objectWidth = objectBoundingRect.width / viewportTransform[0];

//       // snap by the horizontal center line
//       if (isInRange(objectLeft, activeObjectLeft)) {
//         verticalInTheRange = true;
//         verticalLines.push({
//           x: objectLeft,
//           y1: (objectTop < activeObjectTop)
//             ? (objectTop - objectHeight / 2 - aligningLineOffset)
//             : (objectTop + objectHeight / 2 + aligningLineOffset),
//           y2: (activeObjectTop > objectTop)
//             ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
//             : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
//       }

//       // snap by the left edge
//       if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
//         verticalInTheRange = true;
//         verticalLines.push({
//           x: objectLeft - objectWidth / 2,
//           y1: (objectTop < activeObjectTop)
//             ? (objectTop - objectHeight / 2 - aligningLineOffset)
//             : (objectTop + objectHeight / 2 + aligningLineOffset),
//           y2: (activeObjectTop > objectTop)
//             ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
//             : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(objectLeft - objectWidth / 2 + activeObjectWidth / 2, activeObjectTop), 'center', 'center');
//       }

//       // snap by the right edge
//       if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
//         verticalInTheRange = true;
//         verticalLines.push({
//           x: objectLeft + objectWidth / 2,
//           y1: (objectTop < activeObjectTop)
//             ? (objectTop - objectHeight / 2 - aligningLineOffset)
//             : (objectTop + objectHeight / 2 + aligningLineOffset),
//           y2: (activeObjectTop > objectTop)
//             ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
//             : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center');
//       }

//       // snap by the vertical center line
//       if (isInRange(objectTop, activeObjectTop)) {
//         horizontalInTheRange = true;
//         horizontalLines.push({
//           y: objectTop,
//           x1: (objectLeft < activeObjectLeft)
//             ? (objectLeft - objectWidth / 2 - aligningLineOffset)
//             : (objectLeft + objectWidth / 2 + aligningLineOffset),
//           x2: (activeObjectLeft > objectLeft)
//             ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
//             : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center');
//       }

//       // snap by the top edge
//       if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
//         horizontalInTheRange = true;
//         horizontalLines.push({
//           y: objectTop - objectHeight / 2,
//           x1: (objectLeft < activeObjectLeft)
//             ? (objectLeft - objectWidth / 2 - aligningLineOffset)
//             : (objectLeft + objectWidth / 2 + aligningLineOffset),
//           x2: (activeObjectLeft > objectLeft)
//             ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
//             : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
//       }

//       // snap by the bottom edge
//       if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
//         horizontalInTheRange = true;
//         horizontalLines.push({
//           y: objectTop + objectHeight / 2,
//           x1: (objectLeft < activeObjectLeft)
//             ? (objectLeft - objectWidth / 2 - aligningLineOffset)
//             : (objectLeft + objectWidth / 2 + aligningLineOffset),
//           x2: (activeObjectLeft > objectLeft)
//             ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
//             : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
//         });
//         activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop + objectHeight / 2 - activeObjectHeight / 2), 'center', 'center');
//       }
//     }

//     if (!horizontalInTheRange) {
//       horizontalLines.length = 0;
//     }

//     if (!verticalInTheRange) {
//       verticalLines.length = 0;
//     }
//   });

//   canvas.on('before:render', function() {
//     canvas.clearContext(ctx);
//   });

//   canvas.on('after:render', function() {
//     for (let i = verticalLines.length; i--; ) {
//       drawVerticalLine(verticalLines[i]);
//     }
//     for (let i = horizontalLines.length; i--; ) {
//       drawHorizontalLine(horizontalLines[i]);
//     }

//     verticalLines.length = horizontalLines.length = 0;
//   });

//   canvas.on('mouse:up', function() {
//     verticalLines.length = horizontalLines.length = 0;
//     canvas.renderAll();
//   });
// }


// function initCenteringGuidelines(canvas) {

//   var canvasWidth = canvas.getWidth(),
//       canvasHeight = canvas.getHeight(),
//       canvasWidthCenter = canvasWidth / 2,
//       canvasHeightCenter = canvasHeight / 2,
//       canvasWidthCenterMap = { },
//       canvasHeightCenterMap = { },
//       centerLineMargin = 4,
//       centerLineColor = 'rgba(255,0,241,0.5)',
//       centerLineWidth = 1,
//       ctx = canvas.getSelectionContext(),
//       viewportTransform;

//   for (let i = canvasWidthCenter - centerLineMargin, len = canvasWidthCenter + centerLineMargin; i <= len; i++) {
//     canvasWidthCenterMap[Math.round(i)] = true;
//   }
//   for (let i = canvasHeightCenter - centerLineMargin, len = canvasHeightCenter + centerLineMargin; i <= len; i++) {
//     canvasHeightCenterMap[Math.round(i)] = true;
//   }

//   function showVerticalCenterLine() {
//     showCenterLine(canvasWidthCenter + 0.5, 0, canvasWidthCenter + 0.5, canvasHeight);
//   }

//   function showHorizontalCenterLine() {
//     showCenterLine(0, canvasHeightCenter + 0.5, canvasWidth, canvasHeightCenter + 0.5);
//   }

//   function showCenterLine(x1, y1, x2, y2) {
//     ctx.save();
//     ctx.strokeStyle = centerLineColor;
//     ctx.lineWidth = centerLineWidth;
//     ctx.beginPath();
//     ctx.moveTo(x1 * viewportTransform[0], y1 * viewportTransform[3]);
//     ctx.lineTo(x2 * viewportTransform[0], y2 * viewportTransform[3]);
//     ctx.stroke();
//     ctx.restore();
//   }

//   var isInVerticalCenter,
//       isInHorizontalCenter;

//   canvas.on('mouse:down', function () {
//     viewportTransform = canvas.viewportTransform;
//   });

//   canvas.on('object:moving', function(e) {
//     var object = e.target,
//         objectCenter = object.getCenterPoint(),
//         transform = canvas._currentTransform;

//     if (!transform) return;

//     isInVerticalCenter = Math.round(objectCenter.x) in canvasWidthCenterMap,
//     isInHorizontalCenter = Math.round(objectCenter.y) in canvasHeightCenterMap;

//     if (isInHorizontalCenter || isInVerticalCenter) {
//       object.setPositionByOrigin(new fabric.Point((isInVerticalCenter ? canvasWidthCenter : objectCenter.x), (isInHorizontalCenter ? canvasHeightCenter : objectCenter.y)), 'center', 'center');
//     }
//   });

//   canvas.on('before:render', function() {
//     canvas.clearContext(ctx);
//   });

//   canvas.on('after:render', function() {
//     if (isInVerticalCenter) {
//       showVerticalCenterLine();
//     }
//     if (isInHorizontalCenter) {
//       showHorizontalCenterLine();
//     }
//   });

//   canvas.on('mouse:up', function() {
//     // clear these values, to stop drawing guidelines once mouse is up
//     isInVerticalCenter = isInHorizontalCenter = null;
//     canvas.renderAll();
//   });
// }
